// convx scripts

(function () {
  "use strict";

  function createBackToTopButton() {
    // Create back to top button
    const button = document.createElement("button");
    button.setAttribute("id", "backToTopBtn");
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1.5em; height: 1.5em; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M491.217455 232.401455 11.147636 712.448c-11.031273 10.914909-11.031273 28.904727 0 39.959273 11.054545 11.031273 29.021091 11.031273 40.005818 0L512 291.560727 972.869818 752.407273c11.031273 11.031273 28.928 11.031273 40.005818 0 11.031273-11.054545 11.031273-29.044364 0-39.959273L532.829091 232.401455C527.127273 226.653091 519.517091 224.046545 512 224.279273 504.482909 224.046545 496.919273 226.653091 491.217455 232.401455"/></svg>`;
    button.onclick = scrollToTop;

    // Append button to body
    document.body.appendChild(button);

    // Create style element
    const style = document.createElement("style");
    style.textContent = `
      /* Style for the back to top button */
      #backToTopBtn {
        display: none;
        position: fixed;
        bottom: 85px;
        right: 30px;
        z-index: 4;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-color: white;
        border: 1px solid #ddd;
        padding: 10px;
        cursor: pointer;
        transition: opacity 0.3s ease;
      }

      /* Style for screens smaller than 768px */
      @media (max-width: 767px) {
        #backToTopBtn {
          right: 10px;
          bottom: 115px;
          left: unset;
        }
      }

      /* Style for the .embedded-service element */
      .embedded-service {
        z-index: 5;
      }
    `;

    // Append style to head
    document.head.appendChild(style);

    const styleProduct = document.createElement("style");
    styleProduct.textContent = `
      /* Style for the back to top button */
      #backToTopBtn {
        bottom: 95px;
      }

      /* Style for screens smaller than 768px */
      @media (max-width: 767px) {
        #backToTopBtn {
          bottom: 200px !important;
        }
        .embedded-service .fab {
          bottom: 140px !important;
        }
      }
    `;

    if (window.location.href.includes("/products")) {
      // Append style to head
      document.head.appendChild(styleProduct);
    }

    // Code by Ruby - Convx - #2751
    const styleCart = document.createElement("style");
    styleCart.textContent = `
      /* Style for screens smaller than 1390px */
      @media (max-width: 1390px) {
        #backToTopBtn {
          bottom: 200px !important;
        }
        .embedded-service .fab {
          bottom: 140px !important;
        }
      }
    `;

    if (window.location.href.includes("/cart")) {
      document.head.appendChild(styleCart);
    }
    // End of #2751
    
    // Function to scroll to the top of the page smoothly
    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    // Function to show/hide the back to top button based on scroll position
    window.addEventListener("scroll", function () {
      var btn = document.getElementById("backToTopBtn");
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        btn.style.display = "block";
      } else {
        btn.style.display = "none";
      }
    });
  }

  function collapseTopProduct() {
    console.log('Fox collapseTopProduct run');

    let navigationStripe; // Declare navigationStripe outside of the functions

    // Function to collapse the navigation stripe
    function collapseNav() {
      console.log('Collapse navigation stripe');

      /* const style = document.createElement("style");
      style.textContent = `
        div#shopify-section-navigation_stripe, div#shopify-section-navigation_stripe.minimise div{
          position: relative;
          max-height:120px;
          transition: all 0.5s ease-out;
        }
        .convx__navigation_stripe-btn {
          all: unset;
          display: flex;
          position: absolute;
          height: 25px;
          width: 25px;
          bottom: -25px;
          right: 2.55em;
          z-index: 2;
          border-bottom-right-radius: 8px;
          border-bottom-left-radius: 8px;
          box-shadow: 0px 4px 16px -5px rgba(0,0,0,0.24);
          -webkit-box-shadow: 0px 4px 16px -5px rgba(0,0,0,0.24);
          -moz-box-shadow: 0px 4px 16px -5px rgba(0,0,0,0.24);
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all .5s ease;
        }
        .convx__navigation_stripe-btn.minimise svg {
          transform: scaleY(1) !important;
        }
        div#shopify-section-navigation_stripe.minimise {
          padding: 0;
          max-height: 0;
          transition: all 0.5s ease-out;
        }
          div#shopify-section-navigation_stripe{
            overflow: unset !important;
          }

          div#shopify-section-navigation_stripe.minimise .nav-left-arrow, div#shopify-section-navigation_stripe.minimise .nav-right-arrow {
          height: 0;
          transition: height 0.5s ease-out;
          }
        div#shopify-section-navigation_stripe.minimise .nav-right-arrow:before, div#shopify-section-navigation_stripe.minimise .nav-left-arrow:before {
           content: none;
        }
      `;
      document.head.append(style); */

      const button = document.createElement("button");
      button.classList.add('convx__navigation_stripe-btn');
      if(navigationStripe.classList.contains("minimise")){
        button.classList.add('minimise');
      }

      const svgIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svgIcon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svgIcon.setAttribute("class", "svg-icon");
      svgIcon.setAttribute("style", "width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden; transform: scaleY(-1);");
      svgIcon.setAttribute("viewBox", "0 0 1024 1024");
      svgIcon.setAttribute("version", "1.1");

      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("d", "M948.560332 281.179984c-13.765515-13.833053-36.127825-13.833053-49.89334 0L511.991302 668.591431 125.313565 281.179984c-13.763468-13.798261-36.093033-13.798261-49.856501 0-13.799284 13.798261-13.799284 36.161594 0 49.993624l410.857439 411.674037c7.067976 7.085372 16.402575 10.521634 25.675776 10.331299 9.274224 0.191358 18.608823-3.245927 25.677822-10.331299l410.891208-411.708829c6.863315-6.89913 10.331299-15.940041 10.331299-24.979928S955.423647 288.078091 948.560332 281.179984z");

      svgIcon.appendChild(path);
      button.appendChild(svgIcon);

      navigationStripe.appendChild(button);

      button.addEventListener('click', function () {
        navigationStripe.classList.toggle('minimise');
        button.classList.toggle('minimise');
      });
    }

    // Define a function to check for the navigation stripe and slick slider
    function checkElements() {
      navigationStripe = document.getElementById("shopify-section-navigation_stripe_inner"); // Assign value to navigationStripe
      const slickSlider = navigationStripe ? navigationStripe.querySelector('.slick-slider') : null;

      if (navigationStripe && slickSlider) {
        console.log('Both navigation stripe and slick slider found. Proceeding.');
        clearInterval(intervalId); // Stop checking once both elements are found
        collapseNav(); // Call the function to collapse the navigation stripe
      } else {
        console.log('Navigation stripe or slick slider not found. Continuing to check...');
      }
    }

    // Set up a setInterval to call the checkElements function every second
    const intervalId = setInterval(checkElements, 1000);

    // Set up a setTimeout to stop checking after one minute (60 seconds)
    setTimeout(function() {
      console.log('Timeout: Stopping further checks.');
      clearInterval(intervalId); // Stop the interval
    }, 60000); // 60 seconds
  }

  async function clearCartEvent() {
    const lastClearTime = localStorage.getItem("lastClearTime");

    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    const currentMinute = currentTime.getMinutes();

    const nextClearTime = new Date();
    nextClearTime.setHours(4, 0, 0, 0); // Set to 4:00 AM
    nextClearTime.setDate(nextClearTime.getDate() + 1); // Set to the next day

    if (!lastClearTime || currentTime >= new Date(lastClearTime)) {
      // Call the function to remove everything in the Shopify cart
      fetch("/cart/clear.js", { method: "POST" })
        .then(() => {
          console.log("Flushing");
          localStorage.setItem("lastClearTime", nextClearTime);
        })
        .finally(() => {
          // Reload the page only if on the cart page
          // if (window.location.href.includes("/cart")) {
          //   window.location.reload();
          // }
          $.get("/cart?view=minicart", function(itemData) {
            $('.cart-count-bubble').remove();
            $("#cart-notification").text("");
            var textreplace = "<div id='min-cart-replace'></div>";
            $("#cart-notification").append(textreplace);
            $("#cart-notification").replaceWith(itemData);

        });
      });
    }
  }

  function onDOMContentLoaded() {
    console.log('Fox run')
    clearCartEvent()
    collapseTopProduct();
    createBackToTopButton();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();

// View more
(() => {
  "use strict";

  class ViewMore {
    constructor(root) {
      this.root = root;

      this.viewMoreButton = document.createElement("button");
      this.viewMoreButton.type = "button";
      this.viewMoreButton.classList.add("view-more-button");
      this.viewMoreButton.textContent = "View more";
      this.viewMoreButton.addEventListener("click", this.toggleContent.bind(this));

      this.originalInnerHTML = this.root.innerHTML;
      const originalText = this.root.textContent;
      const characterCount = this.getCharacterCount(originalText);

      if (characterCount < originalText.length) {
        this.root.textContent = `${originalText.slice(0, characterCount)}... `;
        this.root.append(this.viewMoreButton);
      }
    }

    toggleContent() {
      if (this.viewMoreButton.textContent === "View more") {
        this.viewMoreButton.remove();
        this.viewMoreButton.textContent = "View less";
        this.root.innerHTML = this.originalInnerHTML;
        this.root.append(this.viewMoreButton);
      } else {
        this.viewMoreButton.remove();
        this.viewMoreButton.textContent = "View more";
        this.originalInnerHTML = this.root.innerHTML;

        const originalText = this.root.textContent;
        const characterCount = this.getCharacterCount(originalText);

        if (characterCount < originalText.length) {
          this.root.textContent = `${originalText.slice(0, characterCount)}... `;
          this.root.append(this.viewMoreButton);
        }
      }

      const panel1 = this.root.closest(".panel1");

      if (panel1) {
        panel1.style.setProperty("max-height", `${panel1.scrollHeight}px`);
      }
    }

    getCharacterCount(originalText) {
      let characterCount = this.root.dataset.viewMore;

      if (characterCount) {
        characterCount = Number.parseInt(characterCount);
      } else {
        characterCount = 120;
      }

      while (characterCount < originalText.length && originalText.at(characterCount) !== " " && characterCount < 140) {
        characterCount += 1;
      }

      return characterCount;
    }
  }

  // Code by Ruby - Convx - #2261 - move this function from section/main-product.liquid
  function updateFeaturesMarkup(val) {
    if (val.dataset.updated) {
      // This element has already been updated.
      return;
    }
  
    const $container = document.querySelector('.overviewPanel');
    const $list = document.createElement('ul');
    const $content = val.innerHTML;
  
    if ($content && $content?.length > 0) {
      const $items = $content.split(/<br\s*\/?>/i);
  
      if ($items?.length > 0) {
        $items.forEach((item) => {
          const $listItem = document.createElement('li');
          $listItem.innerHTML = item.trim();
          $list.appendChild($listItem);
        });
  
        val.innerHTML = '';
        val.appendChild($list);
  
        if ($container && $container?.style?.maxHeight) {
          $container.style.maxHeight = $container.scrollHeight + 'px';
        }
      }
    }
  
    val.dataset.updated = "true";
  }
  // End of #2261

  function main() {
    // Code by Ruby - Convx - #2261 - move this function from section/main-product.liquid
    const featuresValue = document.querySelector('.js-features-value') || null;
    if (featuresValue) {
      updateFeaturesMarkup(featuresValue);
    }
    // End of #2261

    document.querySelectorAll("[data-view-more]").forEach(element => {
      element.viewMore = new ViewMore(element);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }
})();
// End view more

// Convx modal
(() => {
  "use strict";

  class ConvxModal {
    constructor(root) {
      this.root = root;
      this.dialog = this.root.querySelector(`[role="dialog"]`);

      this.root.querySelectorAll("[data-convx-modal-close-button]").forEach(button => {
        button.addEventListener("click", this.hide.bind(this));
      });

      this.root.addEventListener("click", event => {
        if (event.target === this.root) {
          this.hide();
        }
      });

      document.addEventListener("keyup", event => {
        if (event.key === "Escape" && !this.root.hidden) {
          this.hide();
        }
      });
    }

    show() {
      document.documentElement.classList.add("convx-modal--not-scrollable");
      this.root.hidden = false;
      this.dialog.focus();
    }

    hide() {
      document.documentElement.classList.remove("convx-modal--not-scrollable");
      this.root.hidden = true;
    }
  }

  window.ConvxModal = ConvxModal;

  function main() {
    document.querySelectorAll("[data-convx-modal").forEach(element => {
      element.convxModal = new ConvxModal(element);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }
})();
// End convx modal

// Convx gallery
(() => {
  "use strict";

  class ConvxGallery {
    constructor(root) {
      this.root = root;
      this.imageContainer = this.root.querySelector("[data-convx-gallery-image-container]");
      this.dots = Array.from(this.root.querySelectorAll("[data-convx-gallery-dot]"));

      this.dots.forEach((dot, i) => {
        dot.addEventListener("click", this.dotClicked.bind(this, i));
      });

      this.intersectionObserver = new IntersectionObserver(this.imageIntersected.bind(this), {
        root: this.imageContainer,
        threshold: 0.5,
      });

      for (const image of this.imageContainer.children) {
        this.intersectionObserver.observe(image);
      }
    }

    destruct() {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
      this.dots = null;
      this.imageContainer = null;
      this.root = null;
    }

    dotClicked(index) {
      const image = this.imageContainer.children[index];
      this.imageContainer.scrollTo({
        left: image.offsetLeft,
        behavior: "smooth",
      });
    }

    imageIntersected(entries) {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.5) {
          for (let i = 0; i < this.imageContainer.children.length; ++i) {
            if (this.imageContainer.children[i] === entry.target) {
              this.dots.forEach(x => { x.removeAttribute("data-convx-gallery-dot-selected"); });
              this.dots[i].setAttribute("data-convx-gallery-dot-selected", "");
              break;
            }
          }
        }
      });
    }
  }

  window.ConvxGallery = ConvxGallery;

  function main() {
    document.querySelectorAll("[data-convx-gallery").forEach(element => {
      element.convxGallery = new ConvxGallery(element);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }
})();
// End convx gallery

// Quick view
(() => {
  "use strict";

  class QuickView {
    static cache = new Map();

    static arrayEquals(a1, a2) {
      return a1.length === a2.length && a1.every((x, i) => x === a2[i]);
    }

    constructor(root) {
      this.root = root;
      const parameters = this.root.dataset.quickViewButton.split("|");
      this.baseCollectionHandle = parameters[0];
      this.productHandle = parameters[1];
      this.popUp = {
        root: null,
        products: null,
        selectedProduct: null,
        gallery: null,
        imageContainer: null,
        dotContainer: null,
        title: null,
        compareAtPrice: null,
        compareAtPriceData: null,
        priceData: null,
        addToCartButton: null,
        buyNowButton: null,
        optionGroups: null,
        inputs: null,
      };
      this.root.addEventListener("click", this.quickViewButtonClicked.bind(this));
    }

    async quickViewButtonClicked() {
      this.root.disabled = true;

      if (!this.popUp.root) {
        await this.fetchPopUp();
      }

      this.popUp.selectedProduct = this.popUp.products.find(x => x.handle === this.productHandle);
      this.renderSelectedProduct();
      this.popUp.root.convxModal.show();
      this.root.disabled = false;
    }

    async fetchPopUp() {
      const popUp = QuickView.cache.get(this.baseCollectionHandle);

      if (popUp) {
        this.popUp = popUp;
        return;
      }

      const response = await fetch(`${window.Shopify.routes.root}products/${this.productHandle}?section_id=quick-view`);
      const text = await response.text();
      const div = document.createElement("div");
      div.innerHTML = text;
      this.popUp.root = div.children[0];
      this.popUp.root.removeAttribute("id");
      this.popUp.root.className = "convx-modal__backdrop";
      this.popUp.root.setAttribute("data-convx-modal", "");
      this.popUp.root.hidden = true;
      this.popUp.root.convxModal = new ConvxModal(this.popUp.root);
      this.popUp.products = JSON.parse(this.popUp.root.querySelector("[data-quick-view-products-json]").textContent);
      this.popUp.gallery = this.popUp.root.querySelector("[data-convx-gallery]");
      this.popUp.imageContainer = this.popUp.root.querySelector("[data-quick-view-image-container]");
      this.popUp.dotContainer = this.popUp.root.querySelector("[data-quick-view-dot-container]");
      this.popUp.title = this.popUp.root.querySelector("[data-quick-view-title]");
      this.popUp.compareAtPrice = this.popUp.root.querySelector("[data-quick-view-compare-at-price]");
      this.popUp.compareAtPriceData = this.popUp.root.querySelector("[data-quick-view-compare-at-price-data]");
      this.popUp.priceData = this.popUp.root.querySelector("[data-quick-view-price-data]");
      this.popUp.addToCartButton = this.popUp.root.querySelector("[data-quick-view-add-to-cart]");
      this.popUp.addToCartButton.addEventListener("click", this.addToCartButtonClicked.bind(this));
      this.popUp.buyNowButton = this.popUp.root.querySelector("[data-quick-view-buy-now]");
      this.popUp.optionGroups = Array.from(this.popUp.root.querySelectorAll("[data-quick-view-option-group]"));
      this.popUp.inputs = this.popUp.optionGroups.map(group => Array.from(group.querySelectorAll("[data-quick-view-option-input]")));
      this.popUp.inputs.forEach(group => {
        group.forEach(input => {
          input.addEventListener("change", this.optionChanged.bind(this));
        });
      });
      document.body.append(this.popUp.root);
      QuickView.cache.set(this.baseCollectionHandle, this.popUp);
    }

    optionChanged(event) {
      const checkedOptions = this.popUp.inputs.map(group => group.find(input => input.checked).value);
      this.popUp.selectedProduct = this.popUp.products.find(x => QuickView.arrayEquals(x.options, checkedOptions));

      if (!this.popUp.selectedProduct) {
        const groupIndex = this.popUp.inputs.findIndex(group => group.some(input => input === event.target));
        this.popUp.selectedProduct = this.popUp.products.find(x => x.options[groupIndex] === event.target.value);
      }

      this.renderSelectedProduct();
    }

    renderSelectedProduct() {
      if (this.popUp.gallery.convxGallery) {
        this.popUp.gallery.convxGallery.destruct();
        this.popUp.gallery.convxGallery = null;
      }

      this.popUp.imageContainer.innerHTML = this.popUp.selectedProduct.image_tags.join("");
      this.popUp.dotContainer.innerHTML = this.popUp.selectedProduct.image_tags
        .map((_, i) => `<button class="quick-view__gallery-dot" type="button" data-convx-gallery-dot ${i == 0 ? "data-convx-gallery-dot-selected" : ""}><span class="sr-only">View image ${i + 1}</span></button>`)
        .join("");
      this.popUp.gallery.convxGallery = new ConvxGallery(this.popUp.gallery);

      this.popUp.title.textContent = this.popUp.selectedProduct.title;

      this.popUp.compareAtPrice.hidden = !this.popUp.selectedProduct.compare_at_price;
      this.popUp.compareAtPriceData.textContent = this.popUp.selectedProduct.compare_at_price || "";
      this.popUp.priceData.textContent = this.popUp.selectedProduct.price;

      this.popUp.optionGroups.forEach((group, i) => {
        const colorData = group.querySelector("[data-quick-view-color-data]");

        if (colorData) {
          colorData.textContent = this.popUp.selectedProduct.options[i];
        }
      });

      this.popUp.inputs.forEach((group, i) => {
        group.find(input => input.value === this.popUp.selectedProduct.options[i]).checked = true;
      });
      this.popUp.buyNowButton.href = this.popUp.selectedProduct.url;

      if (this.popUp.selectedProduct.available) {
        if (this.popUp.selectedProduct.is_preorder) {
          this.popUp.addToCartButton.textContent = this.popUp.addToCartButton.dataset.quickViewPreorderText;
        } else {
          this.popUp.addToCartButton.textContent = this.popUp.addToCartButton.dataset.quickViewAddToCartText;
        }
        this.popUp.addToCartButton.disabled = false;
      } else {
        if (this.popUp.selectedProduct.is_coming_soon) {
          this.popUp.addToCartButton.textContent = this.popUp.addToCartButton.dataset.quickViewComingSoonText;
        } else {
          this.popUp.addToCartButton.textContent = this.popUp.addToCartButton.dataset.quickViewSoldOutText;
        }
        this.popUp.addToCartButton.disabled = true;
      }
    }

    async addToCartButtonClicked() {
      this.popUp.addToCartButton.disabled = true;

      const item = {
        id: this.popUp.selectedProduct.variant_id,
        quantity: 1,
        properties: {},
      };

      if (this.popUp.selectedProduct.is_preorder) {
        item.properties["_preOrder"] = true;
        item.properties["_preOrderMessage"] = this.popUp.selectedProduct.preorder_message;
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({ items: [ item ] }),
      });
      const json = await response.json();
      document.dispatchEvent(new CustomEvent("cart-updated", { detail: json }));

      const response2 = await fetch(`${window.Shopify.routes.root}cart?view=minicart`);
      const text = await response2.text();
      const div = document.createElement("div");
      div.innerHTML = text;
      const count = div.querySelector("#cart-notification-button .count").textContent;

      document.querySelectorAll(".cart-icon-bubble").forEach(icon => {
        icon.innerHTML = `<div class="cart-count-bubble"><span>${count}</span></div>`;
      });

      const cartNotification = document.querySelector("cart-notification");
      cartNotification.querySelector("#cart-notification").remove();
      cartNotification.insertAdjacentElement("afterbegin", div.querySelector("#cart-notification"));
      this.popUp.root.convxModal.hide();
      cartNotification.querySelector("#cart-notification").classList.add("minicart-active");

      if (this.popUp.selectedProduct.available) {
        this.popUp.addToCartButton.disabled = false;
      } else {
        this.popUp.addToCartButton.disabled = true;
      }
    }
  }

  function main() {
    document.querySelectorAll("[data-quick-view-button]").forEach(element => {
      element.quickView = new QuickView(element);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }
})();
// End quick view
